var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1686 2.01186C9.74588 1.72938 9.25412 1.72938 8.83142 2.01186L8.81612 2.02189L3.25491 5.577C2.6404 5.96904 2.3 6.64554 2.3 7.32342V14.9185C2.3 15.6355 2.86633 16.2 3.57612 16.2H15.4239C16.1337 16.2 16.7 15.6355 16.7 14.9185V7.32342C16.7 6.62238 16.3291 5.99382 15.7276 5.56584L10.1839 2.02189L10.1686 2.01186ZM11.1605 0.50982C10.1365 -0.169944 8.8634 -0.169938 7.8395 0.509826L2.2861 4.05995C2.28623 4.05988 2.28598 4.06003 2.2861 4.05995C1.12771 4.79916 0.5 6.06234 0.5 7.32342V14.9185C0.5 16.6253 1.86799 18 3.57612 18H15.4239C17.132 18 18.5 16.6253 18.5 14.9185V7.32342C18.5 5.9295 17.7486 4.78494 16.7468 4.082C16.7362 4.07457 16.7255 4.06738 16.7146 4.06041L11.1605 0.50982Z",
    fill: "#362F41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.97ee11d80fb6ff9ac99522d04accf673.svg";
export { ForwardRef as ReactComponent };